<div class="fixed z-20 inset-0 bg-gray-900 bg-opacity-60 overflow-y-auto h-full w-full flex items-center justify-center animate__animated " [class]="!isClosing ? 'animate__fadeIn' : 'animate__fadeOut'">

    <div class="relative shadow-xl rounded-lg bg-white w-full min-h-screen flex flex-col animate__animated " [class]="!isClosing ? 'animate__fadeInDown' : 'animate__fadeOutUp'">

        <shared-loader *ngIf="isLoading" message="Cargando..." [is-loading]="isLoading"></shared-loader>

        <div #viewer class="viewer" style="height: 100vh; width: 100%; margin: 0 auto;"></div>

    </div>

</div>
